import React from "react";

import Categoriproduct from "../components/ui/Categoriproduct";

const Snacks = () => {
  return (
    <div>
      <Categoriproduct />
    </div>
  );
};

export default Snacks;
